
import React, { Component } from 'react';
import moment     from 'moment';
import FotoPerfil from './renderFotoPerfil';
import Lightbox   from 'react-images';

class TimeLine extends Component {

      
    constructor(props) {
      super(props);
      this.state = {lightboxIsOpen : false}
    }

    closeLightbox(){
      this.setState({lightboxIsOpen:false})
    }
    
    openImg(){
      this.setState({lightboxIsOpen:true})
    }
    
    render() {
       
      const renderTipoMidia = (this.props.tipo === 2 ? <a href={void(0)} className="ligthBoxPost" onClick={this.openImg.bind(this)}>
        {this.props.postMidia}
        {this.props.midia? <Lightbox
         images  = {[{ src: this.props.midia }]}
         isOpen  = {this.state.lightboxIsOpen}
         onClose = {this.closeLightbox.bind(this)}  /> : ""}
        
      </a>: this.props.postMidia );

       const margin = {marginBottom: '10px'}   

        return (
            <li className="timeline-inverted" id={`post_item_${this.props.id}`}>
            <div className="timeline-panel">
                <div className="timeline-body">
                        <div className="media-raking">
                          <div className="media-left">
                            <FotoPerfil width="40" height="40" className="media-object img-rounded" src={this.props.foto}/>
                           </div>
                           <div className="media-body">
                             <span className="media-heading user-nome-post"><b>{this.props.nome}</b></span>
                              {this.props.btAcao}
                              <p className="data-post">{moment(this.props.dataCriado).format("DD/MM/YYYY")}</p>
                            </div>
                        </div>
                    <p style={margin}>{this.props.postConteudo}</p>
                    {renderTipoMidia}
                </div>
                <div className="timeline-panel-footer timeline-foot-comments">
                  {this.props.footerPost}  
                </div>
            </div>
        </li>);
    }
}

export default TimeLine;



// WEBPACK FOOTER //
// ./src/container/renderTimeLineEquipe.js